import { LANGUAGE_UPDATED, UI_UPDATED } from './types';

export const actionBuilder = () => {
  // User override expected
  const updateUi = async (store, routeName) => {
    store.commit(`ui/${ UI_UPDATED }`, { routeName }, { root: true });
  };

  const setLanguage = ({ commit, state }, language) => {
    if (state.language !== language) {
      commit(`ui/${ LANGUAGE_UPDATED }`, language, { root: true });
    }
  };

  return {
    updateUi,
    setLanguage,
  };
};
